import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import withTranslations from '../../utils/HighOrderComponent';
import ModalForDocumentPreview from '../Reusable/ModalForDocumentPreview';

class SignetExampleRow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPreview: false,
    };
  }

  showModalPreview = () => {
    this.setState({ showPreview: true });
  };

  handleDownloadClick = () => {
    const { id } = this.props.signetExample || {};
    const messages = this.props.t.NotificationMessages;
    this.props.downloadExample(messages, id);
  };

  handlePreviewClose = () => {
    this.setState({
      showPreview: false,
    });
  };

  render() {
    const { signetExample, index } = this.props || {},
      { embeddableAttribute } = signetExample || {};

    const signetExampleRowContent = (
      <tr>
        <td>{index}</td>
        <td>{embeddableAttribute.name}</td>
        <td className="text-center">
          <Link onClick={this.showModalPreview} to="#">
            <i className="fas fa-search fa-2x" />
          </Link>
        </td>
        <td className="text-center">
          <Link id="downloadFile" onClick={this.handleDownloadClick} to="#">
            <i className="fas fa-download"></i>
          </Link>
        </td>
      </tr>
    );

    return (
      <Fragment>
        {signetExampleRowContent}
        {this.state.showPreview && (
          <ModalForDocumentPreview
            documentName={embeddableAttribute.uuidName}
            controllerReference={'signetExample'}
            handleClose={this.handlePreviewClose}
            show={this.state.showPreview}
          />
        )}
      </Fragment>
    );
  }
}

export default withTranslations(SignetExampleRow, 'SignetExampleRow');
